<template>
    <div class="watchlist-infobox">
        <div class="watchlist-infobox__statuses">
            <p v-if="selectedWatchList.mode !== null && !selectedWatchList.isReadonly" class="watchlist-infobox__status">
                <span class="icon-share watchlist-infobox__icon"></span>
                <span v-html="$t('Watchlist.infobox.shared')"></span>
            </p>
            <p v-if="selectedWatchList.isReadonly" class="watchlist-infobox__status">
                <span class="icon-share watchlist-infobox__icon" style="background: transparent;"></span>
                <span v-html="$t('Watchlist.infobox.readonly')"></span>
            </p>
            <p v-if="selectedWatchList.mode === null && !selectedWatchList.isReadonly" class="watchlist-infobox__status">
                <span class="icon-user watchlist-infobox__icon"></span>
                <span v-html="$t('Watchlist.infobox.normal')"></span>
            </p>
            <p v-if="selectedWatchList.isHidden" class="watchlist-infobox__status">
                <span class="icon-eye-blocked watchlist-infobox___icon"></span>
                <span v-html="$t('Watchlist.infobox.hidden')"></span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'watch-list-info-box',
    props: {
        selectedWatchList: {
            type: Object
        },
        rightAlign: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.watchlist-infobox {
    margin: 20px 0 0;
    display: flex;
    flex-direction: column;
    font-family: Nunito-Regular, sans-serif;
    font-size: 1.4rem;

    [class*="mobile"] & {
        margin: 10px 0 0 0;
    }

    [class*="mobile"] & {
        width: 100%;
    }

    &__status {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__icon {
        font-size: 1.6rem;
        margin-right: 5px;
    }
}
</style>
